import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "*", component: () => import("@/views/others/404.vue") },
  {
    path: "/",
    component: () => import("@/views/auth/Layout.vue"),
    meta: { isPublic: true },
    redirect: { name: "login" },
    children: [
      {
        path: "login",
        name: "login",
        meta: { title: "Login" },
        component: () => import("@/views/auth/Login.vue"),
      },
    ],
  },
  {
    path: "/apps",
    component: () => import("@/views/auth/_Layout.vue"),
    meta: { isPublic: false },
    redirect: { name: "aplicativos" },
    children: [
      {
        path: "aplicativos",
        name: "aplicativos",
        component: () => import("@/views/application/Apps.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
